<!--  -->
<template>
  <div class="comContent">
    <!-- <MyTabs class="myTabs"
            :tabi="tabsIndex"
            :tabs="tabsData"
            numhide
            @change="tabChange" /> -->
    <Tabs
      @tab-click="handleClick"
      style="padding: 0 24px"
      :tabsList="tabsList"
      :activeName.sync="activeName"
    ></Tabs>
    <div class="topHeader">
      <div>
        <el-form ref="formTool" :model="formTool" :inline="true" style="display: flex">
          <el-form-item prop="createBy" size="small">
            <el-input v-model="formTool.createBy" clearable placeholder="请输入发起人" />
          </el-form-item>
          <!-- <el-form-item prop="content"
                        size="small">
            <el-select v-model="formTool.content"
                       clearable
                       placeholder="售后发起方">
              <el-option v-for="li in options"
                         :key="li.value"
                         :label="li.label"
                         :value="li.value" />
            </el-select>
          </el-form-item> -->
        </el-form>
      </div>
      <div style="display: flex;">
        <MyButton type="primary" text="查询" @click="getList(1)" />
        <MyButton type="" text="重置" @click="reset()" />
      </div>
    </div>

    <div class="center">
      <MyTable
        v-if="tableData.length > 0"
        :table-data="tableData"
        :index="index"
        :selection="selection"
        :page="page"
        :operation="operation"
        :table-option.sync="tableOption"
        @page-change="getList"
      >
        <template slot="caozuo" slot-scope="scope">
          <el-link
            style="margin-left: 10px"
            type="primary"
            :underline="false"
            @click="detail(scope.row)"
          >
            详情
          </el-link>
        </template>
      </MyTable>
      <el-empty v-else style="height: 100%" description="暂无数据" />
    </div>
    <SuggestionDetailDlg ref="suggestionDetail" @refreshCornerMark="getCornerMark" @refreshList="getList" />
  </div>
</template>

<script>
import { page, insert, list, cornerMark } from "@/api/suggestion";
import ImgUpload from "@/components/imgUpload";
import MyButton from "@/components/myButton";
import MyTable from "@/components/myTable";
import Tabs from "@/components/Tabs";
import SuggestionDetailDlg from "./components/suggestionDetailDlg";
import { drugenumeration } from "@/utils/enumeration";
import { aftersalePage, aftersaleBuyerAgree } from "@/api/afterSales/serviceSheet";
export default {
  components: { MyButton, MyTable, Tabs, ImgUpload, SuggestionDetailDlg },
  data() {
    return {
      tabsList: [
        // tabs 传的值
        {
          name: "0",
          label: "待处理",
          value: 0,
        },
        {
          name: "1",
          label: "已处理",
          value: 0,
        },
      ],
      activeName: "0", // tabs 传的值
      formTool: {
        createBy: "",
      },
      operation: false,
      selection: false,
      index: false,
      tableData: [],
      tableOption: [
        { label: "发起人", prop: "createBy" },
        { label: "更新时间", prop: "updateTime" },
        {
          label: "操作",
          prop: "caozuo",
          width: "80px",
          slot: true,
          align: "center",
        },
      ],
      page: {
        total: 10,
        current: 1,
        size: 10,
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getList();
    this.getCornerMark();
  },
  mounted() {},
  methods: {
    // 查询角标
    getCornerMark() {
      cornerMark({type: 'OPS'}).then((res) => {
        this.tabsList[0].value = res
      });
    },
    // 查询
    getList(current) {
      if (current) {
        this.page.current = current;
      }
      let params = {
        ...this.formTool,
        status: this.activeName,
        size: this.page.size,
        current: this.page.current,
      };
      page(params).then((res) => {
        const { records, total } = res.page;
        this.tableData = records;
        this.page.total = total;
      });
    },
    // 重置查询条件
    reset() {
      // this.formTool.storeName = ''
      this.$refs.formTool.resetFields();
      this.page.current = 1;
      this.getList();
    },
    // 点击tab
    handleClick() {
      this.getList(1);
    },
    // 查看详情
    detail(row) {
      // 新逻辑
      this.$refs.suggestionDetail.init(row.id, this.activeName);
    },
  },
};
</script>
<style lang="scss" scoped>
.comContent {
  padding: 0px;
}
.expand {
  &_box {
    padding: 20px 30px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  &_li {
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    width: 45%;
    margin-right: 3%;
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 10px;
    word-break: break-all;
    strong {
      margin-right: 10px;
      font-weight: 400;
      color: #000;
    }
    span {
      color: #666;
    }
    &_more {
      position: relative;
    }
    &_link {
      color: #f5222d;
      &:hover {
        color: #3db4b9;
      }
    }
    &_img {
      width: 100px;
      height: 100px;
    }
  }
}
.center {
  margin: 0 24px;
  height: calc(100% - 170px);
}
.myTabs {
  height: 56px;
  padding: 0 24px;
  border-bottom: 1px solid #f5f5f5 !important;
}
.topHeader {
  padding: 0 24px;
  display: flex;
  text-align: left;
  align-items: center;
  height: 56px;
  line-height: 56px;
}
.el-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 0px !important;
}
</style>
